import React from 'react'
import TasksBoard from '../components/TasksBoard'
import { FullWidthContent } from '../components/Layout'

const Tasks: React.FC = () => (
  <FullWidthContent>
    <TasksBoard />
  </FullWidthContent>
)

export default Tasks 